/* Write-only consent transport. No email, customer data, URL or checkout token. */
(function(window){
 'use strict';
 if(window.hbCheckoutConsent||!window.hbAnalyticsIdentity)return;
 var endpoint='https://honeybunner-sync.duckdns.org/api/v2/storefront/66c3e902-05fc-455c-bdb8-f8e297502c24/checkout-events';
 var identity=window.hbAnalyticsIdentity,uuid=/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
 var lastKey='hb.checkout.last.v1',revokeKey='hb.checkout.revoke.v1',pending=[],busy=false,attempts=0,grant=null;
 function read(key){try{return window.localStorage.getItem(key);}catch(_){return null;}}
 function write(key,value){try{if(value===null)window.localStorage.removeItem(key);else window.localStorage.setItem(key,value);}catch(_){}}
 var previous=read(lastKey);if(!uuid.test(previous||''))previous=null;
 try{var saved=JSON.parse(read(revokeKey));if(Array.isArray(saved))pending=saved.filter(function(v){return typeof v==='string'&&uuid.test(v);}).slice(0,10);}catch(_){}
 function persist(){write(revokeKey,pending.length?JSON.stringify(pending):null);}
 function revoke(id){if(id&&pending.indexOf(id)<0){pending.push(id);pending=pending.slice(-10);persist();}}
 function live(value){var current=identity.getSnapshot();return value&&current&&value.visitor_id===current.visitor_id&&value.consent_epoch===current.consent_epoch;}
 function flush(){
  if(busy||typeof window.fetch!=='function')return;
  if(grant&&!live(grant))grant=null;
  var denied=pending[0],value=denied?{visitor_id:denied}:grant;
  if(!value)return;
  busy=true;
  var eventId;try{eventId=window.crypto.randomUUID();}catch(_){eventId='consent-'+Date.now();}
  var controller=typeof window.AbortController==='function'?new window.AbortController():null;
  var timeout=controller?window.setTimeout(function(){controller.abort();},8000):null;
  var body={visitor_id:value.visitor_id,event_id:eventId,event:'consent',analytics_consent:!denied};
  Promise.resolve().then(function(){
   if(!denied&&!live(value))return {ok:true};
   return window.fetch(endpoint,{method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'application/json','X-HB-Pixel-Session':'1'},body:JSON.stringify(body),keepalive:true,signal:controller?controller.signal:undefined});
  }).then(async function(response){
   if(!response.ok)throw Error('CONSENT_TRANSPORT_FAILED');
   if(!denied&&response.status===200){var receipt=await response.json();if(live(value)&&receipt&&uuid.test(receipt.pixel_token||''))write('hb.checkout.pixel.v1.'+value.visitor_id,receipt.pixel_token);}
   if(denied){write('hb.checkout.pixel.v1.'+denied,null);pending=pending.filter(function(id){return id!==denied;});persist();}else if(grant===value)grant=null;
   attempts=0;
  }).catch(function(){attempts+=1;}).finally(function(){
   if(timeout!==null)window.clearTimeout(timeout);busy=false;
   if(!attempts)flush();else if(attempts<4)window.setTimeout(flush,[0,1000,3000,10000][attempts]);
  });
 }
 function changed(snapshot){
  var consent=window.hbConsentMode&&window.hbConsentMode.lastGoogleState||{};
  if(!snapshot&&consent.wait_for_update!=null)return;
  if(previous&&(!snapshot||snapshot.visitor_id!==previous))revoke(previous);
  previous=snapshot?snapshot.visitor_id:null;write(lastKey,previous);
  grant=snapshot;attempts=0;flush();
 }
 window.hbCheckoutConsent={retry:function(){attempts=0;flush();}};
 identity.subscribe(changed);
 if(window.hbConsentMode&&typeof window.hbConsentMode.addListener==='function')window.hbConsentMode.addListener(function(state){if(state&&state.wait_for_update==null&&state.analytics_storage!=='granted')changed(null);});
 if(typeof window.addEventListener==='function')window.addEventListener('online',window.hbCheckoutConsent.retry);
 flush();
})(window);
